import { collection, getDocs, addDoc, Firestore, query, where } from 'firebase/firestore';
import { DEFAULT_STATUSES } from '../types';

export const migrateDefaultStatuses = async (firestore: Firestore, workspaceId: string): Promise<void> => {
  const statusesRef = collection(firestore, `workspaces/${workspaceId}/statuses`);
  
  // Check for existing statuses
  for (const defaultStatus of DEFAULT_STATUSES) {
    // Check if this specific status already exists
    const existingStatus = await getDocs(
      query(statusesRef, where('name', '==', defaultStatus.name))
    );
    
    // Only add if this specific status doesn't exist
    if (existingStatus.empty) {
      try {
        await addDoc(statusesRef, {
          ...defaultStatus,
          createdAt: new Date().toISOString() // Add creation timestamp
        });
        console.log(`Added default status: ${defaultStatus.name}`);
      } catch (error) {
        console.error(`Error adding default status ${defaultStatus.name}:`, error);
      }
    } else {
      console.log(`Status ${defaultStatus.name} already exists, skipping`);
    }
  }
  
  console.log('Default statuses migration completed');
};